import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicCircleEmailOnboardingDisabled({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 56 56"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <circle cx={28} cy={28} r={28} fill="#CCC" />
      <g clipPath="url(#pic_circle_email-onboarding-disabled_svg__a)">
        <path
          fill="#fff"
          d="M15 19c0-1.1.9-2 2-2h22a2 2 0 012 2v15a2 2 0 01-2 2H17a2 2 0 01-2-2z"
        />
        <path
          fill="#CCC"
          d="M23.48 26.26l1.13 1.13L15 37l-1.13-1.13zm8.99-.06l-1.14 1.13L41 37l1.13-1.13z"
        />
        <path
          fill="#CCC"
          d="M26.02 29.09L11.43 14.5l1.14-1.13 14.58 14.59a1.2 1.2 0 001.7 0l14.59-14.6 1.13 1.14-14.59 14.59a2.8 2.8 0 01-3.96 0"
        />
      </g>
      <circle cx={38} cy={37} r={9} fill="#E3E8E8" />
      <path
        fill="#fff"
        d="M42.5 37a4.2 4.2 0 00-3.17-4.18l-.17-.03-.08-.02a.8.8 0 01.28-1.57l.08.01.25.05A5.8 5.8 0 0144.1 37a5.8 5.8 0 01-4.66 5.79.8.8 0 01-.28-1.58A4.2 4.2 0 0042.5 37"
      />
      <path
        fill="#fff"
        d="M36.23 33.93a.8.8 0 011.07-.05l.07.05 2.5 2.5.05.06a.8.8 0 010 1.01l-.05.07-2.5 2.5a.8.8 0 11-1.14-1.14l1.14-1.13H32.8a.8.8 0 010-1.6h4.57l-1.14-1.13-.05-.07a.8.8 0 01.05-1.07"
      />
      <defs>
        <clipPath id="pic_circle_email-onboarding-disabled_svg__a">
          <rect width={26} height={19} x={15} y={17} fill="#fff" rx={2} />
        </clipPath>
      </defs>
    </svg>
  );
}

SvgPicCircleEmailOnboardingDisabled.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicCircleEmailOnboardingDisabled.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicCircleEmailOnboardingDisabled svgRef={ref} {...props} />
));
export default ForwardRef;
